module.exports = __webpack_public_path__ + "static/media/4.0228ed5c.jpg";